import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ListView from '../utils/ListView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Enums from '../../enums';

class MemberPointApp extends React.Component
{
    // E_TYPE = {
    //     ALL: 0,
    //     SINGLE: 1 
    // };

    constructor(props){
        super(props);
        Tools.init();
        API.init(this);
        
        setTimeout( function(){
            alert("[TODO] 沒有提供介面和對應欄位資料");
        },500);
        this.state = {
            // ty: this.E_TYPE.ALL,
            tac: this.props.match.params["id"] || "",
            list: [],
            page_max: 20,
            filter: null,
            list_index_min:0,
            list_index_max:20,
            page_index:0,
            fields: [
                "日期",
                "任務/禮物名稱",
                "支出/收入點數",
                "累積總點數"
            ]
        };
        this.getData();
        this.onListViewClicked = this.onListViewClicked.bind(this);
    }
    getData(){
        var tmpData = {
            tac: this.state.tac
        };
        API.GetMemberPointRecord(tmpData, this.onDataUpdated.bind(this));
    }

    onListViewClicked(index){
        console.log(index);
    }

    onDataUpdated(data){
        console.log(this);
        if( data && data.data ){
            console.log(data);
            const tmp = [];
            /* {
                "gid": "",
                "is_win": 0,
                "pid": "P181210151508",
                "type": 1,
                "point": 300,
                "ct": 1551056189447,
                "ex_time": 1609430399999,
                "adid": "",
                "serial": {},
                "name": "乎乾啦！",
                "cash_point": 0,
                "comment": "",
                "total_point": 300
            } */
            for( let index in data.data ) {
                const tmpObj = data.data[index];
                // "日期",
                // "任務/禮物名稱",
                // "支出/收入點數",
                // "累積總點數"
                tmp.push({
                    key: tmpObj.pid,
                    data: [
                        Tools.getFormatDate(tmpObj.ct),
                        tmpObj.name,
                        tmpObj.point,
                        tmpObj.total_point
                    ]
                });
            }
            this.setState({
                list: tmp
            })
        }
    }
    render() {
        const { list, page_max, filter, list_index_min, list_index_max, fields } = this.state,
            totalEntries = list.length,
            onListViewClicked = this.onListViewClicked;
        return (
            <div>
                <ListView list={list} 
                          fields={fields}
                          title={"點數紀錄"}
                          onRowClicked={onListViewClicked}/>
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(MemberPointApp),
//     document.getElementById('root')
// );
const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(MemberPointApp))